module.exports = __webpack_public_path__ + "media/images/services/mt-20adf5e4fa636cdf7def2bfc1c16680f.svg";